var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakPad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 11.375v4.375a3.5 3.5 0 003.5 3.5h5.25a3.5 3.5 0 003.5-3.5v-4.375H4.375zm-.389-1.75c-.752 0-1.361.61-1.361 1.361v4.764c0 2.9 2.35 5.25 5.25 5.25h5.25c2.9 0 5.25-2.35 5.25-5.25v-4.764c0-.752-.61-1.361-1.361-1.361H3.986z",
    fill: "#e95832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.125H7M7 1.75v8.75M14 1.75v8.75M14.875 1.75h-8.75M14 16.625H7",
    stroke: "#e95832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/break_pad.9c8d1ea2.svg";
export { SvgBreakPad as ReactComponent };